const hasSearch = document.getElementsByClassName('dynamic-card--search');

// Check whether a dynamic card search feature has been enabled
if (hasSearch.length > 0) {
  // List of all dynamic card search buttons for use with an event listener
  const allSearchSubmitButtons = document.querySelectorAll(
    '.dynamic-card--search .dynamic-card--search-inner button',
  );

  // List of all dynamic card search inputs for use with an event listener
  const allSearchInputs = document.querySelectorAll(
    '.dynamic-card--search .dynamic-card--search-inner input',
  );

  // List of all dynamic card search term containers for use with an event listener
  const allSearchTermContainers = document.querySelectorAll(
    '.dynamic-card--search .dynamic-card--search-terms ul',
  );

  // The maximum number of search terms allowed
  const maxTerms = 5;

  const parseSearchTerm = value => {
    const termsArray = value.trim().split(' ');
    return termsArray.filter(term => term.length > 1 && term.length < 30);
  };

  const addSearchTerm = (searchTermContainer, searchInput) => {
    const { value } = searchInput;
    const terms = parseSearchTerm(value);

    // Double check for empty search and stop
    if (terms.length === 0) {
      return;
    }

    terms.forEach(term => {
      if (searchTermContainer.childElementCount === maxTerms) {
        return;
      }

      const searchTermLi = document.createElement('li');
      const searchTermButton = document.createElement('button');
      searchTermButton.classList.add('button');
      searchTermButton.textContent = term;
      searchTermButton.setAttribute('aria-label', 'remove');
      searchTermLi.appendChild(searchTermButton);
      searchTermContainer.appendChild(searchTermLi);
    });

    // eslint-disable-next-line no-param-reassign
    searchInput.value = '';
  };

  const removeSearchTerm = target => {
    target.closest('ul').removeChild(target.parentNode);
  };

  const disableSearch = searchContainer => {
    const searchbutton = searchContainer.querySelector('button');
    const searchinput = searchContainer.querySelector('input');
    searchbutton.setAttribute('disabled', true);
    searchinput.setAttribute('disabled', true);
  };

  const enableSearch = searchContainer => {
    const searchbutton = searchContainer.querySelector('button');
    const searchinput = searchContainer.querySelector('input');
    searchbutton.removeAttribute('disabled');
    searchinput.removeAttribute('disabled');
  };

  const filterCards = (terms, cards, mode = 'and') => {
    let clonedCardsContainer;

    // Restore original cards back if no search terms
    if (terms.childElementCount === 0) {
      // eslint-disable-next-line no-param-reassign
      cards.style.display = '';
      cards.nextElementSibling.parentNode.removeChild(cards.nextElementSibling);

      return;
    }

    // Reuse previous copied container or clone original
    if (cards?.nextElementSibling?.classList?.contains('clone')) {
      // eslint-disable-next-line no-param-reassign
      cards.nextElementSibling.innerHTML = '';
      clonedCardsContainer = cards?.nextElementSibling;
    } else {
      clonedCardsContainer = cards.cloneNode();
      clonedCardsContainer.classList.add('clone');
      clonedCardsContainer.setAttribute('aria-live', 'polite');
      clonedCardsContainer.setAttribute('aria-relevant', 'additions removals');
    }

    const termsTextArray = Array.from(terms?.children).map(term => term?.textContent);

    cards.children.forEach(card => {
      const cardTitle = card
        ?.querySelector('.cardItem-body .cardItem-header .cardItem-title a')
        ?.textContent.trim();
      const cardContent = card
        ?.querySelector('.cardItem-body .cardItem-content')
        ?.textContent.trim();
      const fullCardString = [cardTitle, cardContent].join(' ').toLowerCase();
      const showCard = [];

      // Builds the show card boolean table
      termsTextArray.forEach(term => {
        showCard.push(fullCardString.includes(term.toLowerCase()));
      });

      // Card has to match all search terms
      if (!showCard.includes(false) && mode === 'and') {
        const clonedCard = card.cloneNode(true);
        clonedCardsContainer.appendChild(clonedCard);
      }

      // Card has to match only one search term
      if (showCard.includes(true) && mode !== 'and') {
        const clonedCard = card.cloneNode(true);
        clonedCardsContainer.appendChild(clonedCard);
      }
    });

    // eslint-disable-next-line no-param-reassign
    cards.style.display = 'none';

    // Set a notice if no cards are found
    if (clonedCardsContainer.childElementCount === 0) {
      const noticeParagraph = document.createElement('p');
      noticeParagraph.textContent = 'No items found.';
      clonedCardsContainer.appendChild(noticeParagraph);
    }

    // Adds filtered cards directly after original card container
    cards.insertAdjacentElement('afterend', clonedCardsContainer);
  };

  const handleSearchTermClick = event => {
    // Bypass click event listener attached to document
    event.stopPropagation();

    const { target } = event;
    const searchContainer = target?.closest('.dynamic-card--search');
    const searchMode = searchContainer?.dataset?.mode;
    const searchTermContainer = searchContainer?.querySelector('.dynamic-card--search-terms ul');
    const searchCardsContainer = searchContainer?.nextElementSibling;

    if (target.tagName === 'BUTTON') {
      removeSearchTerm(target);
      enableSearch(searchContainer);

      // Stop running if adjascent container isn't the card list
      if (!searchCardsContainer?.classList?.contains('cardItem-list')) {
        return;
      }

      filterCards(searchTermContainer, searchCardsContainer, searchMode);
    }
  };

  const handleSearchSubmitClick = event => {
    if (event.type === 'keyup' && event?.keyCode !== 13) {
      return;
    }

    const { target } = event;
    const searchContainer = target?.closest('.dynamic-card--search');
    const searchMode = searchContainer?.dataset?.mode;
    const searchInput = searchContainer?.querySelector('input');
    const searchTermContainer = searchContainer?.querySelector('.dynamic-card--search-terms ul');
    const searchCardsContainer = searchContainer?.nextElementSibling;

    // Stop running if value is empty
    if (!searchInput.value.trim()) {
      return;
    }

    // Stop running if value less than 2
    if (searchInput.value.trim().length < 2) {
      return;
    }

    // Stop running if adjascent container isn't the card list
    if (!searchCardsContainer?.classList?.contains('cardItem-list')) {
      return;
    }

    addSearchTerm(searchTermContainer, searchInput);
    filterCards(searchTermContainer, searchCardsContainer, searchMode);

    // Disable search if max terms has been reached
    if (searchTermContainer.childElementCount >= maxTerms) {
      disableSearch(searchContainer);
    }
  };

  allSearchSubmitButtons.forEach(searchButton =>
    searchButton.addEventListener('click', handleSearchSubmitClick),
  );

  allSearchInputs.forEach(searchInputs =>
    searchInputs.addEventListener('keyup', handleSearchSubmitClick),
  );

  allSearchTermContainers.forEach(searchTermContainer =>
    searchTermContainer.addEventListener('click', handleSearchTermClick),
  );
}
